import React, { useCallback, useEffect, useRef } from 'react';
import { useProfileBits } from '@/src/hooks/use-fetch-bits';
import { Bits } from '../../exploreStories/components/BitsList';

type Props = {
  userUniqueLink: string;
};

export const BitsSection = ({ userUniqueLink }: Props) => {
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useProfileBits(userUniqueLink);
  const loadMoreRef = useRef<HTMLDivElement>(null);
  const allPages = data?.pages ?? [];
  const bits = allPages.flatMap((page) => page.bits);

  const loadMore = useCallback(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          loadMore();
        }
      },
      { threshold: 0.1, rootMargin: '800px' }
    );

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }
    return () => {
      if (loadMoreRef.current) {
        observer.unobserve(loadMoreRef.current);
      }
    };
  }, [loadMore]);

  return (
    <div className="w-full">
      <Bits
        bits={bits}
        loading={isLoading}
        hasNextPage={hasNextPage}
        loadMore={loadMore}
        loadMoreRef={loadMoreRef}
        isProfile={true}
      />
    </div>
  );
};
